module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/207-guam-3759a6825672b29eb713c43de7820023.svg";